import type { Theme } from '../../contract.js';
import { obsidianLight, obsidianDark } from './variants.js';

/**
 * Obsidian family — violet accent, brand-green charging. Promoted
 * from `skin_obsidian` overlay during the Driver Themes ticket and
 * recolored from slate to purple to pair with the new dripping-
 * sphere shader's palette.
 *
 * Satellite Streets basemap for both modes. The purple chrome
 * lives on the dark variant; the dripping-sphere shader carries
 * the visual identity on the active session screen.
 */
export const obsidianTheme: Theme = {
  // Identifier stays 'obsidian' for backward compat — every User
  // with active_theme_family: 'obsidian' keeps working, no DB
  // migration churn. Only the driver-facing display `name` + copy
  // change to 'Drip' (this commit). Folder path, family ID,
  // ThemeFamilyId union, and the legacy skin_obsidian references
  // all stay on the 'obsidian' identifier.
  id: 'obsidian',
  name: 'Drip',
  description: 'Liquid chrome with brand-green energy.',
  swatches: ['#0A0510', '#A030C0', '#F0E5FA'],
  variants: { light: obsidianLight, dark: obsidianDark },
  unlockedByDefault: true,
  costPoints: 0,
  mapStyle: {
    light: 'mapbox://styles/mapbox/satellite-streets-v12',
    dark: 'mapbox://styles/mapbox/satellite-streets-v12',
  },
  chargingAnimation: 'shader',
  shaderKind: 'obsidian',
};
